import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "担当課登録")
], -1)
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "d-flex justify-content-center my-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2 mb-2"
}, "登録", -1)

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { ConciergeDepartment, useNicotto } from '@/plugins/nicotto'
import DepartmentForm from '@/components/forms/ConciergeDepartment.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewView',
  setup(__props) {

const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()
const department = ref<ConciergeDepartment>(new ConciergeDepartment())

const save = async() => {
  try {
    await nicotto.concierge.createDepartment(department.value)
    messenger.set('concierge.departments.saveSucceeded')
    router.push('/concierge/departments')
  } catch (err) {
    console.log(err)
    for (let i = 0; i < err.errors.length; i++) {
      if (err.errors[i].message.indexOf('data is already exists.') !== -1 ) {
        messenger.set('concierge.departments.saveFailedAlreadyExists')
        return
      }
    }
    messenger.set('concierge.departments.saveFailed')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DepartmentForm, {
        modelValue: department.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((department).value = $event)),
        onSubmit: save
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/concierge/departments",
              class: "btn btn-secondary mx-2 mb-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})